export default __webpack_public_path__ + "static/media/location.c32ce4b4.svg";